// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./free-damm-limon.jpg')
const allTwoEs = require('./animated-es.gif')
const allTwoCa = require('./animated-ca.gif')
const allFourEs = require('./static-es.png')
const allFourCa = require('./static-ca.png')
const catalogTwoEs = require('./animated-es.gif')
const catalogTwoCa = require('./animated-ca.gif')
const catalogFourEs = require('./static-es.png')
const catalogFourCa = require('./static-ca.png')

const model = creativityMediaModel({
  catalogID: 'beer',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
